import type { ConversationListItem } from '../api/useAdminConversations';

export function isUnread(
  messageCreatedAt: string,
  lastReadAt?: string,
): boolean {
  if (!lastReadAt) return true;
  return new Date(messageCreatedAt).getTime() > new Date(lastReadAt).getTime();
}

export function computeHasUnread(
  items: ConversationListItem[],
  readMap: Record<string, string>,
): boolean {
  return items.some((item) =>
    isUnread(item.last_message.created_at, readMap[item.conversation.id]),
  );
}
